import { MappedClass, MappedProperty } from '@h5s/util-object';
import { CashRegisterConfigurablePayment } from './cash-register-configurable-payment';
import { CashRegisterPaymentType } from './cash-register-payment-type.enum';
import { ZPrinterFiscalConfigPaymentAmountExchangeType } from './z-printer-fiscal-config-payment-amount-exchange-type';
import { ZPrinterFiscalConfigPaymentType } from './z-printer-fiscal-config-payment-type';

@MappedClass()
export class ZPrinterFiscalConfigPaymentIn {
  // Il DTO REST espone anche un campo "index" (slot hardware del pagamento), volutamente non mappato qui:
  // per i pagamenti ci limitiamo al solo enumerato "type", l'indice non è gestito da questa configurazione
  @MappedProperty()
  name: string | null;

  @MappedProperty()
  type: ZPrinterFiscalConfigPaymentType;

  @MappedProperty()
  change: boolean;

  @MappedProperty()
  drawer: boolean;

  @MappedProperty()
  amount_exchange_type: ZPrinterFiscalConfigPaymentAmountExchangeType;

  @MappedProperty()
  amount_required = false;

  @MappedProperty()
  pay_discount: boolean;

  private static readonly typeMap: Record<CashRegisterPaymentType, ZPrinterFiscalConfigPaymentType> = {
    [CashRegisterPaymentType.Cash]: ZPrinterFiscalConfigPaymentType.cash,
    [CashRegisterPaymentType.Cheque]: ZPrinterFiscalConfigPaymentType.cheque,
    [CashRegisterPaymentType.Card]: ZPrinterFiscalConfigPaymentType.card,
    [CashRegisterPaymentType.WireTransfer]: ZPrinterFiscalConfigPaymentType.wireTransfer,
    [CashRegisterPaymentType.NotCollected]: ZPrinterFiscalConfigPaymentType.notCollected,
    [CashRegisterPaymentType.NotCollectedInvoice]: ZPrinterFiscalConfigPaymentType.notCollectedInvoice,
    [CashRegisterPaymentType.PayDiscount]: ZPrinterFiscalConfigPaymentType.payDiscount,
    // singleTicket, multipleTickets, notCollectedGoods, notCollectedServices, notCollectedSnn, payDiscountVoucherMultiUse
    // non hanno un corrispondente in CashRegisterConfigurablePaymentTypeEnum
  };

  /**
   * Tipo cassa corrispondente a un pagamento ZStay, o undefined se non mappato.
   * Usato sia per costruire il payload da inviare sia per confrontare la programmazione riletta, così la tabella resta una sola.
   */
  public static resolveType(type: CashRegisterPaymentType): ZPrinterFiscalConfigPaymentType | undefined {
    return ZPrinterFiscalConfigPaymentIn.typeMap[type];
  }

  public fromPayment(payment: CashRegisterConfigurablePayment): void {
    this.name = payment.description;

    // typeMap è esaustiva su CashRegisterPaymentType, ma il DTO CashRegisterPaymentTypeEnumDto ha un valore in più (ELECTRONIC, deprecato) che la nostra enum non copre: se il backend lo restituisse, qui arriverebbe un valore fuori mappa.
    // Meglio fallire esplicitamente che mandare un type undefined alla cassa
    const type = ZPrinterFiscalConfigPaymentIn.resolveType(payment.type);
    if (!type) {
      throw new Error(
        `[ZPrinterFiscalConfigPaymentIn] Tipo di pagamento non mappato per '${payment.description}': '${payment.type}'`,
      );
    }
    this.type = type;
    this.amount_exchange_type = ZPrinterFiscalConfigPaymentAmountExchangeType.pos;
    this.pay_discount = payment.type === CashRegisterPaymentType.PayDiscount;
    this.change = payment.type === CashRegisterPaymentType.Cash;
    this.drawer = payment.type === CashRegisterPaymentType.Cash || payment.type === CashRegisterPaymentType.Cheque;
  }
}
